import { Button, Col, Row, Text } from 'components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const AthleteImg = styled.img`
  width: 377px;
  margin: 30px 0 0;

  @media (max-width: 1024px) {
    margin: 15px 0 0 24px;
    width: 237px;
  }
`;

const SignUpContainer = styled.div`
  margin: 50px 0 0;

  button {
    width: 178px;
  }
`;

const SliderElement = ({ title, content, image }) => {
  const navigate = useNavigate(),
    { t } = useTranslation();

  return (
    <Row>
      <AthleteImg src={image || require('assets/images/tennis-phone-tilted.png')} />

      <Col marg="90px 0 0 27px">
        <Text size="42px" med spacing="-1px">
          {title}
        </Text>

        <Text size="28px" marg="6px 0 0" lineHt="32px">
          {content}
        </Text>

        <SignUpContainer>
          <Button
            text={t('website.signUp')}
            website
            sportsSelect
            marg="0 20px 0 0"
            onClick={() => navigate('/signup')}
          />
        </SignUpContainer>
      </Col>
    </Row>
  );
};

export default SliderElement;
